module.exports = "Select the crop option under “Image Adjust” step"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/CropImages/crop-images-how-to-step-two.md
// module id = 1151
// module chunks = 0